import React from "react";
import styled from "styled-components";
import { Accordion } from "react-accessible-accordion";

const StyledAccordion = styled(Accordion)`
  width: 100%;
  text-align: left;
`;

export default function ExpanderList({ children }) {
  return (
    <StyledAccordion allowZeroExpanded allowMultipleExpanded>
      {children}
    </StyledAccordion>
  );
}
